import { memo } from "react";
import Screen from "ui/layouts/Screen";
import { ECommercePlatformSetup } from "ui/organizms/Home";

const ECommercePlatformSetupScreen = () => (
    <Screen
        title='ECommerce Platform Setup'
    >
        <ECommercePlatformSetup />
    </Screen>
);

export default memo(ECommercePlatformSetupScreen);
